module.exports = __webpack_public_path__ + "static/media/portfolio4.41bb8e20.webp";